import React from 'react';
import { Doughnut as ReactDoughnut } from 'react-chartjs-2';
import { ChartData } from 'chart.js';
import styles from './index.scss';

export interface ChartProps {
  data: ChartData;
  id: string;
  disableTooltips?: boolean;
  children?: React.ReactNode;
}

const defaultOptions = {
  cutout: '85%',
  cutoutPercentage: 40,
  animation: {
    animateScale: false,
    animateRotate: true,
  },
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
};

export const Doughnut = ({ id, data, disableTooltips, children }: ChartProps): any => {
  const disableTooltipOptions = {
    ...defaultOptions,
    plugins: {
      ...defaultOptions.plugins,
      tooltip: {
        enabled: false,
      },
      hover: { mode: null },
    },
  };

  const options = disableTooltips ? disableTooltipOptions : defaultOptions;
  data.datasets.forEach(dataset => {
    const backgroundColors = dataset.backgroundColor as Array<string>;
    if (!backgroundColors || !backgroundColors.length) {
      return;
    }
    dataset.backgroundColor = backgroundColors.map(backgroundColor => {
      return backgroundColor?.replace(/(var\([a-z-0-9]*, )|(\))/g, '');
    });
  });
  return (
    <div className={styles.container}>
      <ReactDoughnut type="doughnut" id={id} data={data} options={options} />
      <div className={styles.label}>{children}</div>
    </div>
  );
};

export default Doughnut;
